export const sidenav = {
  root: {
    color: "{text.body}",
  },
  panel: {
    mainPadding: "{padding.16}",
    mainMobilePadding: "{padding.8} 0",
    padding: "{padding.24} {padding.16}",
    gap: "{gap.24}",
    minWidth: "220px",
    /* height of the bottom nav bar without safe-area-inset-bottom: icon content (42px) + 2x mobile padding + border */
    mobileHeight: "calc(42px + ({padding.8} * 2) + {border.width.1})",
  },
  separator: {
    width: "{border.width.1}",
    color: "{surface.border}",
  },
  list: {
    gap: "{gap.12}",
  },
  link: {
    hoverBackground: "{highlight.support}",
    borderRadius: "{border.radius.8}",
    color: "{text.body}",
    padding: "{padding.8}",
    gap: "{gap.8}",
    fontLeading: "100%",
  },
  icon: {
    fontSize: "24px",
    color: "{text.caption}",
    hoverColor: "{text.heading}",
  },
  label: {
    fontSize: "{typography.body.text.regular.font.size}",
    fontWeight: "600",
    hoverFontWeight: "600",
    color: "{text.body}",
    hoverColor: "{text.body}",
    mobileFontSize: "{typography.mobile.body.text.regular.font.size}",
    mobileFontLeading: "{typography.mobile.body.text.regular.font.leading}",
    mobileFontWeight: "{typography.mobile.body.text.regular.font.weight}",
  },
  colorScheme: {
    light: {
      backgroundLeft:
        "linear-gradient(45deg, rgba(255, 239, 218, 0.90) 0.00%, rgba(238, 245, 228, 0.90) 25.00%, rgba(238, 245, 228, 0.90) 45.00%, rgba(238, 245, 228, 0.90) 65.00%, rgba(212, 255, 244, 0.90) 80.00%, rgba(212, 255, 244, 0.90) 100.00%), {surface.bg-white}",
      backgroundRight: "{surface.bg-white}",
    },
    dark: {
      backgroundLeft: "linear-gradient(117.56deg, {color.slate.800} 22%, {color.slate.900} 100%)",
      backgroundRight: "{color.slate.900}",
    },
  },
};
